module.exports = __webpack_public_path__ + "static/media/map.448b279c.png";